import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import BackButton from '../common/BackButton'
import AiWaitingLogo from '../createPortfolio/aiGeneration/AiWaitingLogo'
import { useNavigate, useParams } from 'react-router-dom'
import { AUTHENTICATED_ROUTES } from '../../resources/routes-constants'

const SubmittedPortfolio: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const onTrackClick = () => {
    navigate(AUTHENTICATED_ROUTES.PORTFOLIO_TRACKING_ROUTE.replace(":id", id as string));
  }

  return <Box display={"flex"} flexDirection={"column"} width={"1400px"}>
    <Box display={"flex"}>
      <BackButton />
    </Box>
    <Box display={"flex"} flexGrow={1} flexDirection={"column"} justifyContent={"flex-start"} alignItems={"center"}>
      <AiWaitingLogo hideAiPart />
      <Typography fontSize={"32px"} fontWeight={"500"} lineHeight={"39.01px"} textAlign={"center"}>Great new! Your portfolio is being reviewed by our lawyers</Typography>
      <Button variant='contained' sx={{ marginTop: "30px", textTransform: "none", width: "200px" }} onClick={onTrackClick}>Track Portfolio</Button>
    </Box>
  </Box>
}

export default SubmittedPortfolio